import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form as FormikForm, Field } from 'formik';
import React from 'react';
import { useEffect } from 'react';
import { Form, Card, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { updateRealEstate } from 'redux/realEstateSlice';
import ButtonPrimarySubmit from 'utils/buttons/ButtonPrimarySubmit';
import { socialNetworksSchema } from '../validations/socialNetworksSchema';
import PropTypes from 'prop-types';

const inputs = [
  {
    label: 'Sitio Web',
    name: 'website',
    icon: ['fa', 'globe'],
    iconClassName: 'logo-web',
    placeholder: 'https://www.mi-inmobiliaria.com'
  },
  {
    label: 'Instagram',
    name: 'instagram',
    icon: ['fab', 'instagram'],
    iconClassName: 'logo-insta',
    placeholder: 'https://www.instagram.com/mi-inmobiliaria'
  },
  {
    label: 'Facebook',
    name: 'facebook',
    icon: ['fab', 'facebook'],
    iconClassName: 'logo-face',
    placeholder: 'https://www.facebook.com/mi-inmobiliaria'
  },
  {
    label: 'Twitter',
    name: 'twitter',
    icon: ['fab', 'twitter'],
    iconClassName: 'logo-twitter',
    placeholder: 'https://www.twitter.com/mi-inmobiliaria'
  },
  {
    label: 'Youtube',
    name: 'youtube',
    icon: ['fab', 'youtube'],
    iconClassName: 'logo-youtube',
    placeholder: 'https://www.youtube.com/mi-inmobiliaria'
  }
];

const InputSocialMedia = ({
  label,
  name,
  icon,
  iconClassName,
  placeholder,
  touched,
  errors
}) => (
  <Col xs={12}>
    <Form.Group>
      <Form.Label>
        <FontAwesomeIcon icon={icon} className={iconClassName} /> {label}
      </Form.Label>

      <Form.Control
        as={Field}
        placeholder={placeholder}
        name={name}
        isInvalid={touched[name] && !!errors[name]}
      />

      <Form.Control.Feedback type="invalid">
        {errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  </Col>
);

InputSocialMedia.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.array.isRequired,
  iconClassName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const SocialMedia = () => {
  const realEstateData = useSelector(state => state.realEstate.data);
  const dispatch = useDispatch();

  const handleSubmit = values => {
    dispatch(updateRealEstate(realEstateData.id, values));
  };

  return (
    <Card className="bg-white">
      <Card.Header className="border-bottom">
        <Card.Title>Redes Sociales</Card.Title>
      </Card.Header>

      <Card.Body>
        <Card.Text>
          Escriba la dirección de sus redes de interés. Éstas se mostrarán en su
          ficha de Inmobiliaria, en la plataforma CABAPROP.
        </Card.Text>

        <Formik
          initialValues={{
            facebook: realEstateData.socialNetworks?.facebook || '',
            instagram: realEstateData.socialNetworks?.instagram || '',
            twitter: realEstateData.socialNetworks?.twitter || '',
            website: realEstateData.socialNetworks?.website || '',
            youtube: realEstateData.socialNetworks?.youtube || ''
          }}
          onSubmit={handleSubmit}
          validationSchema={socialNetworksSchema}
        >
          {({ setValues, touched, errors }) => {
            useEffect(() => {
              if (realEstateData) {
                setValues({
                  facebook: realEstateData.socialNetworks?.facebook || '',
                  instagram: realEstateData.socialNetworks?.instagram || '',
                  twitter: realEstateData.socialNetworks?.twitter || '',
                  website: realEstateData.socialNetworks?.website || '',
                  youtube: realEstateData.socialNetworks?.youtube || ''
                });
              }
            }, [realEstateData]);

            return (
              <FormikForm>
                <Row className="g-3">
                  {inputs.map((input, index) => (
                    <InputSocialMedia
                      key={index}
                      {...input}
                      touched={touched}
                      errors={errors}
                    />
                  ))}

                  <Col xs={12}>
                    <ButtonPrimarySubmit
                      text="Guardar cambios"
                      className="w-100"
                    />
                  </Col>
                </Row>
              </FormikForm>
            );
          }}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default SocialMedia;
